<template>
  <div class="player-container">
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        width="180px"
        prop="loginId">
        <template slot="header" slot-scope="scope">
          <div>用户账号</div>
          <el-input
            v-model="search.loginId"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        prop="trueName">
        <template slot="header" slot-scope="scope">
          <div>用户姓名</div>
          <el-input
            v-model="search.trueName"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        :formatter="formatPayStatus"
        prop="payStatus">
        <template slot="header" slot-scope="scope">
          <div>支付状态</div>
          <el-select v-model="search.payStatus" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in payStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        width="180px"
        :formatter="formatStatus"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>会员单位审核</div>
          <el-select v-model="search.status" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in auditStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-date-picker
            v-model="search.createDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import * as moment from 'moment'
import { getOrganizationPlayerList, updateOrganizationPlayerStatus } from '@/api/club'

const defaultForm = {}
export default {
  name: 'PlayerList',
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      auditStateList: [],
      payStateList: []
    }
  },
  created() {
    this.organizationId = this.$route.params.id
    this.getList()
    this.getAuditList()
  },
  computed: {},
  methods: {
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加用户信息'
      this.dialogForm = defaultForm
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleEdit(index, row) {
      const id = row.id || 123
      this.$router.push({ name: 'CoachEdit', params: { id: id }})
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const params = {
          playerId: row.id,
          status: -2,
        }
        this.updateOrganizationPlayerStatus(params)
      }).catch(() => {
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updatePlayer()
          } else {
            this.addPlayer()
          }
        } else {
          return false
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        organizationId: this.organizationId,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getOrganizationPlayerList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },

    updateOrganizationPlayerStatus(params) {
      const data = {
        organizationId: this.organizationId,
        playerId: params.playerId,
        status: params.status // 0审核中 1拒绝 2通过 -1禁用 -2删除
      }
      updateOrganizationPlayerStatus(data).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },

    deletePlayer(id) {
     this.updateOrganizationPlayerStatus(-2, id)
    },
    getAuditList() {
      this.auditStateList = [
        {value: '', label: '全部'},
        {value: 0, label: '待确认'},
        {value: 1, label: '退回'},
        {value: 2, label: '接收'}
      ]
      this.payStateList = [
        {value: '', label: '全部'},
        {value: 0, label: '待支付'},
        {value: 1, label: '已支付'},
        {value: 2, label: '手动支付'}
      ]
    },

    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    formatPayStatus: function(row, column) {
      const val = row[column.property]
      if (val == 1) {
        return '已支付'
      } else if (val == 2) {
        return '手动支付'
      } else {
        return '待支付'
      }
    },

    formatStatus: function(row, column) {
      const val = row[column.property]
      if (val == 1) {
        return '退回'
      } else if (val == 2) {
        return '接收'
      } else {
        return '待确认'
      }
    },

    reviseState(index, row) {
      const params = {
        playerId: row.id,
        status: row.status,
      }
      this.updateOrganizationPlayerStatus(params)
    }

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .player-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>
